export default __webpack_public_path__ + "static/media/Vector.53fe52bb.svg";